export type KeyValueOrder = { key: string; value: string; order?: number };

export const ExcelProjectSituationItemsFields = [
    // Same structure as ProjectItems (A-G)
    { key: 'Id', value: 'Id', order: undefined },
    { key: 'Ordinal', value: 'Redni broj', order: 0 },
    { key: 'Name', value: 'Opis/Naziv', order: 1 },
    { key: 'UnitOfMeasurement', value: 'Jedinica mjere', order: 2 },
    { key: 'Quantity', value: 'Količina', order: 3 },
    { key: 'UnitPrice', value: 'Jedinična cijena', order: 4 },
    { key: 'TotalPrice', value: 'Ukupna cijena', order: 5 },
    // Contractor-specific columns (H-J)
    { key: 'ContractorQuantity', value: 'Količina izvođača', order: 6 },
    { key: 'ContractorUnitPrice', value: 'Jedinična cijena izvođača', order: 7 },
    { key: 'ContractorTotalPrice', value: 'Ukupna cijena izvođača', order: 8 },
    // Situation-specific columns (K-N)
    { key: 'SituationQuantity', value: 'Količina situacije', order: 9 },
    { key: 'SituationTotalPrice', value: 'Ukupna cijena situacije', order: 10 },
    { key: 'SituationCumulativeQuantity', value: 'Kum. količina', order: 11 },
    { key: 'SituationCumulativePrice', value: 'Kum. cijena', order: 12 },
] as KeyValueOrder[];
